"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ImageContent = _interopRequireDefault(require("./ImageContent"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ImageAttachment = function ImageAttachment(_ref) {
  var attachment = _ref.attachment;
  return _react.default.createElement(_ImageContent.default, {
    alt: attachment.name,
    src: attachment.thumbnailUrl || attachment.contentUrl
  });
};

ImageAttachment.propTypes = {
  activity: _propTypes.default.shape({
    attachments: _propTypes.default.array.isRequired
  }).isRequired,
  // Either attachment.contentUrl or attachment.thumbnailUrl must be specified.
  attachment: _propTypes.default.oneOfType([_propTypes.default.shape({
    contentUrl: _propTypes.default.string.isRequired,
    name: _propTypes.default.string,
    thumbnailUrl: _propTypes.default.string
  }), _propTypes.default.shape({
    contentUrl: _propTypes.default.string,
    name: _propTypes.default.string,
    thumbnailUrl: _propTypes.default.string.isRequired
  })]).isRequired
};
var _default = ImageAttachment;
exports.default = _default;